export default __webpack_public_path__ + "static/media/missedReportIcon.bd9f8afa.svg";